import React from 'react';
import styles from '../Specifications.module.scss';
import { useSelector } from 'react-redux';
import { selectCurrentTeamMemberData } from '../../../../selectors';
import SkillChip from '../SkillChip';

export default function Capacity() {
  const { capacity } = useSelector(selectCurrentTeamMemberData());

  return (
    <div className={styles.specification}>
      <label>Capacity:</label>
      <div className={styles.specification__block}>
        {!!capacity.length &&
          capacity.map((item) => <SkillChip key={item.id} label={item.name || ''} />)}
      </div>
    </div>
  );
}
